import React from 'react';
import { useParams } from 'react-router-dom';
import { Revue } from './Revue';
import { Runup } from './Runup';

const modules = {
    1: Revue,
    2: Runup
};

const Modules = () => {
    const { moduleId } = useParams();
    const Module = modules[moduleId];

    if (!Module) {
        return <Revue />;
    }

    return <Module />;
};

export default Modules;
